var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card drag-item mb-1 px-2 py-1",
      class: {
        rotten: _vm.rottenClass,
        "card-settings-open": _vm.showCardSettings,
      },
      style: _vm.cardColourStyle,
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.showCardSettings
        ? _c("profile-card-setting", {
            attrs: {
              "client-profile-id": _vm.id,
              "client-profile-name": _vm.givenName || _vm.familyName,
              "status-label-id": _vm.statusLabelId,
            },
            on: { hide: _vm.toggleCardSettings },
          })
        : _c(
            "div",
            {
              staticClass: "card-content",
              on: {
                mousedown: _vm.handleMousedown,
                mouseup: _vm.handleMouseup,
                click: _vm.handleClick,
              },
            },
            [
              !_vm.read
                ? _c("i", {
                    staticClass:
                      "text-white bg-danger text-center position-absolute new-email-badge pulse",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm.labelText && !_vm.isDisplayedInSearch
                      ? _c(
                          "span",
                          [
                            _c(
                              "badge",
                              {
                                staticClass: "ml-0 mr-1",
                                style:
                                  "background-color: " +
                                  _vm.labelColour +
                                  " !important",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.labelText) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isDisplayedInSearch
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "clickable bold m-0 client-profile-name d-inline-block align-self-start",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.givenName) +
                                  " " +
                                  _vm._s(_vm.familyName) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("profile-card-custom-fields", {
                    attrs: {
                      "board-id": _vm.boardId,
                      "custom-fields": _vm.orderedCustomFields,
                      "custom-fields-definitions": _vm.customFieldsDefinitions,
                      "is-displayed-in-search": _vm.isDisplayedInSearch,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "left-side",
                        fn: function () {
                          return [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "m-0 text-gray small client-profile-value mr-2",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("formatMoneyValue")(_vm.value)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.hasReferrer
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.left",
                                        value: {
                                          title: _vm.$options.filters.fullName(
                                            _vm.referrer
                                          ),
                                          boundary: "viewport",
                                          noninteractive: true,
                                        },
                                        expression:
                                          "{\n              title: $options.filters.fullName(referrer),\n              boundary: 'viewport',\n              noninteractive: true\n            }",
                                        modifiers: { left: true },
                                      },
                                    ],
                                    staticClass:
                                      "d-flex flex-row align-items-center",
                                  },
                                  [
                                    _c("icon", {
                                      staticClass:
                                        "referrer-icon mr-1 d-none d-lg-block",
                                      attrs: { name: "user-o" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "referrer-name" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("nameFormat")(
                                                _vm.referrer.givenName,
                                                _vm.referrer.familyName
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasVisibleParticipants
                              ? _c(
                                  "div",
                                  { staticClass: "mt-3" },
                                  _vm._l(
                                    _vm.visibleParticipants,
                                    function (participant) {
                                      return _c(
                                        "div",
                                        { key: participant.id },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translatedReferrerTypes[
                                                  participant.type
                                                ] ||
                                                  _vm.$t(
                                                    "client-profile.participants.custom"
                                                  )
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(participant.firstName) +
                                              " " +
                                              _vm._s(participant.lastName) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "right-side",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-flow align-items-center",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm.clientProfileHasLastChanges
                                  ? _c(
                                      "span",
                                      { staticStyle: { "font-size": "1rem" } },
                                      [
                                        _c("client-profile-changelog-popover", {
                                          attrs: {
                                            "client-profile-id": _vm.id,
                                            "board-id": _vm.boardId,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.owner.username !== _vm.currentUser &&
                                !_vm.isDisplayedInSearch
                                  ? _c(
                                      "profile-avatar",
                                      _vm._b(
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.right",
                                              value: {
                                                title:
                                                  _vm.$t("global.words.owner") +
                                                  ": " +
                                                  _vm.owner.givenName +
                                                  " " +
                                                  _vm.owner.familyName,
                                                boundary: "viewport",
                                                noninteractive: true,
                                              },
                                              expression:
                                                "{\n                title: `${$t('global.words.owner')}: ${owner.givenName} ${\n                  owner.familyName\n                }`,\n                boundary: 'viewport',\n                noninteractive: true\n              }",
                                              modifiers: { right: true },
                                            },
                                          ],
                                          staticClass:
                                            "client-profile-owner-avatar--board",
                                          staticStyle: {
                                            width: "1rem",
                                            height: "1rem",
                                          },
                                        },
                                        "profile-avatar",
                                        Object.assign({}, _vm.owner),
                                        false
                                      )
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isDisplayedInSearch
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "reminders-icon activity",
                                        class: _vm._f("activityClass")(
                                          _vm.reminders
                                        ),
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "clickable font-weight-normal",
                                          },
                                          [
                                            _c(
                                              "reminders-popover",
                                              {
                                                attrs: {
                                                  reminders: _vm.reminders,
                                                },
                                                on: {
                                                  "reminder-create":
                                                    _vm.showAddActivityModal,
                                                  "reminder-complete":
                                                    _vm.handleReminderComplete,
                                                  close: _vm.handlePopoverClose,
                                                  change:
                                                    _vm.handleReminderChange,
                                                },
                                              },
                                              [
                                                _c("icon", {
                                                  class: _vm._f(
                                                    "activityClass"
                                                  )(_vm.reminders),
                                                  style:
                                                    "" +
                                                    (_vm.followUpCount == 0
                                                      ? "opacity: 0.5;"
                                                      : ""),
                                                  attrs: { name: "bell" },
                                                }),
                                                _vm._v(" "),
                                                _vm.followUpCount > 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "counter",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.followUpCount
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]
          ),
      _vm._v(" "),
      !_vm.isDisplayedInSearch
        ? _c(
            "a",
            {
              staticClass:
                "card-delete card-dropdown clickable open-profile-actions",
              on: { mousedown: _vm.toggleCardSettings },
            },
            [
              _c("icon", {
                attrs: {
                  name: "" + (_vm.showCardSettings ? "caret-up" : "caret-down"),
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }